import type { ChangelogStoreState } from 'src/stores/changelog/interfaces';

import { LAST_SEEN_CHANGELOG_VERSION, LAST_SEEN_UNRELEASED_FINGERPRINT } from 'src/stores/changelog/localStorageKeys';

const createDefaultChangelogState = (): ChangelogStoreState => ({
	entries: [],
	isLoaded: false,
	lastSeenUnreleasedFingerprint: localStorage.getItem(LAST_SEEN_UNRELEASED_FINGERPRINT),
	lastSeenVersion: localStorage.getItem(LAST_SEEN_CHANGELOG_VERSION),
});

export default createDefaultChangelogState;
